<template>
  <el-row class="userheder">
    <el-col :span="22">
      <el-form
        :inline="true"
        :model="formSearch"
        ref="formSearch"
        class="demo-form-inline"
      >
        <el-col class="date">
          <el-form-item label="日期">
            <el-date-picker
              v-model="formSearch.formdate"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              style="width: 320px"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="产品">
            <product-select
              :value.sync="formSearch.afid"
              placeholder="请选择产品"
              @change="handerAfid"
              :isDefault="true"
              popper-class="BI-select BI-select-product"
            >
            </product-select>
          </el-form-item>
          <!-- </el-col>
        <el-col> -->
          <el-form-item label="维度">
            <el-select v-model="formSearch.dimension" placeholder="全部">
              <el-option label="全部" value="1"></el-option>
              <el-option label="国家和地区" value="2"></el-option>
              <el-option label="渠道" value="3"></el-option>
              <el-option label="campaign" value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="渠道">
            <el-select
              v-model="formSearch.media"
              placeholder="全部"
              multiple
              collapse-tags
              @change="changeSelect"
              class="multipleselect"
              ref="chnlref"
              popper-class="app-select-self"
            >
              <div class="input-search">
                <el-input
                  v-model="text"
                  size="mini"
                  suffix-icon="el-icon-search"
                />
              </div>
              <el-checkbox
                v-model="checked"
                @change="selectAll($event, 'check')"
                >全选</el-checkbox
              >
              <div @click="clickclear" class="clearbutton">
                <span style="font-size: 14px">清空</span>
              </div>

              <el-option
                v-for="item in mediaList.filter(
                  (i) => !text || i.toLowerCase().includes(text.toLowerCase())
                )"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="地区">
            <areaMultiSelect
              :value.sync="formSearch.geo"
              :optionsList="countryList"
            >
            </areaMultiSelect>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit('formSearch')"
              >查询</el-button
            >
          </el-form-item>
        </el-col>
      </el-form>
    </el-col>
    <el-col :span="2" class="headerleft">
      <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <i class="el-icon-refresh" @click="onSubmit('formSearch')" />
      </el-tooltip>
      <el-tooltip
        class="item"
        effect="dark"
        content="下载excel"
        placement="top"
      >
        <i class="el-icon-download" @click="downloadFile" />
      </el-tooltip>
    </el-col>
  </el-row>
</template>
<script>
import { changeshortcutclass, clearallshortcutclass } from "@/utils/tool";
import areaMultiSelect from "@/components/areaMultiSelect.vue";
import moment from "moment";
// import Axios from "axios";
export default {
  components: {
    areaMultiSelect,
  },
  props: {
    showview: Number,
  },
  computed: {
    mediaList: function () {
      return this.$store.state.Summary.mediaList;
    },
  },
  mounted: function () {
    const timer = setInterval(() => {
      if (this.formSearch.afid) {
        clearInterval(timer);
        this.$store.dispatch("getCountryListAndMedia", {
          afid: this.formSearch.afid,
          cb: (result) => {
            console.log(result);
            this.countryList = result.countryList;
            let param = {
              pageSize: 500,
              pageNumber: 1,
              dateStart: moment(this.formSearch.formdate[0]).format("YYYYMMDD"),
              dateEnd: moment(this.formSearch.formdate[1]).format("YYYYMMDD"),
              afid: this.formSearch.afid,
              geo: this.formSearch.geo.join(","),
              dimension: this.formSearch.dimension,
              media: this.formSearch.media.length
                ? this.formSearch.media.join()
                : null,
            };
            this.$store.dispatch("getSummaryList", {
              param,
              cb: () => {
                this.$emit("showLoading", false);
                this.$emit("refreshTable");
              },
            });
          },
        });
      }
    }, 200);
  },
  data() {
    return {
      countryList: [],
      checked: false,
      text: "",
      formSearch: {
        formdate: [
          new Date(new Date().getTime() - 3600 * 1000 * 24 * 6),
          new Date(),
        ],
        afid: null,
        geo: [],
        dimension: "1",
        media: [],
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "当天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("当天", picker.$el);
              }, 0);
            },
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("最近一周", picker.$el);
              }, 0);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("最近一个月", picker.$el);
              }, 0);
            },
          },
          {
            text: "最近2个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 60);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("最近2个月", picker.$el);
              }, 0);
            },
          },
        ],
        onPick: function ({ maxDate, minDate }) {
          clearallshortcutclass(this.$el);
          console.log(maxDate, minDate);
        },
        disabledDate: function (date) {
          if (new Date().getTime() - date.getTime() > 0) {
            return false;
          }
          return true;
        },
        // disabledDate: function(time) {
        //   return time.getTime() > Date.now();
        // }
      },
      value1: "",
      value2: "",
    };
  },
  methods: {
    clickclear() {
      console.log(this.$refs.chnlref);
      this.formSearch.media = [];
    },

    onSubmit(formName) {
      var loadingObj = null;
      if (this.showview == 1) {
        loadingObj = this.$loading({
          lock: true,
          text: "拼命加载中...",
          target: document.querySelector(".normalchart1"),
        });
      }
      this.$emit("reflashchart");
      this.$emit("showLoading", true);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = {
            pageSize: 500,
            pageNumber: 1,
            dateStart: moment(this.formSearch.formdate[0]).format("YYYYMMDD"),
            dateEnd: moment(this.formSearch.formdate[1]).format("YYYYMMDD"),
            afid: this.formSearch.afid,
            geo: this.formSearch.geo.join(","),
            dimension: this.formSearch.dimension,
            media: this.formSearch.media.length
              ? this.formSearch.media.join()
              : null,
          };
          this.$emit("changeColumn", this.formSearch.dimension);
          // Axios.get("/api/getpredictData").then((data) => {
          //   console.log(data);
          //   loadingObj && loadingObj.close();
          // });
          this.$store.dispatch("getPredictData", {
            param,
            cb: () => {
              this.$emit("showLoading", false);
              this.$emit("refreshTable");

              loadingObj && loadingObj.close();
            },
          });
        } else {
          return false;
        }
      });
    },
    downloadFile() {
      this.$emit("downloadFile");
    },
    changeSelect(value) {
      if (
        this.checked &&
        this.formSearch.media.length <
          this.$store.state.Summary.mediaList.length
      ) {
        this.checked = false;
        this.formSearch.media = value;
      }
    },
    selectAll(event, value) {
      if (event) {
        this.formSearch.media = this.$store.state.Summary.mediaList;
      } else {
        value == "check" ? (this.formSearch.media = []) : null;
      }
    },
    handerAfid(e) {
      this.formSearch.geo = [];
      this.$store.dispatch("getCountryList", {
        afid: e,
        cb: (result) => {
          this.countryList = result;
        },
      });
    },
  },
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
@borderline: #e6e6e6;
.el-date-editor--daterange {
  width: 483px;
}
.el-button {
  margin-left: 14px;
  margin-right: 20px;
}
.userheder {
  padding: 10px;
  // border: 1px solid #e6e6e6;
  margin: 2px;
  border-radius: 3px;
  align-items: baseline;
  display: flex;
  min-width: 1200px;
}
.headerleft {
  text-align: right;
  i {
    font-size: 20px;
    margin-right: 10px;
    cursor: pointer;
  }
  i:hover {
    color: #409eff;
  }
}
.el-form-item {
  margin-bottom: 0px;
}
.date {
  // margin-bottom: 10px;
}
.el-checkbox {
  width: 95%;
  text-align: right;
}
.button {
  color: #fff;
  background-color: #5cb85c;
  border-color: #4cae4c;
  border-radius: 4px;
  line-height: 0.5;

  &:hover {
    background-color: #449d44;
    border-color: #398439;
  }
}
.selectedbutton {
  color: rgb(255, 255, 255) !important;
  background-color: red !important;
  border-color: rgb(76, 174, 76) !important;
}
.multipleselect ::v-deep .el-input__inner {
  &::placeholder {
    color: #777777 !important;
  }
}
.input-search {
  width: 90%;
  margin-left: 5%;
}
.clearbutton {
  display: flex;
  // justify-content: center;
  padding: 0 20px;
  height: 34px;
  line-height: 34px;
  box-sizing: border-box;

  &:hover {
    background: #f5f7fa;
    cursor: pointer;
  }
}
</style>
